/**
 *
 * Module:        Component
 * Name:          Guru Chat Dialogs
 * Description:   Provides rename and destructive-delete confirmations for Guru chats
 * Developers:    Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu, Daniela Popescu
 * Copyright:     Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 *
 */

import React, {useEffect, useState} from 'react';
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField
} from '@mui/material';
import {
	GuruDialogDangerButton,
	GuruDialogPrimaryButton,
	GuruDialogSecondaryButton
} from './GuruChatDialogButtons';

export function GuruRenameDialog({chat, labels, busy, onClose, onSave}) {
	const [title, setTitle] = useState('');
	useEffect(() => setTitle(chat ? chat.title || '' : ''), [chat]);
	return (
		<Dialog open={Boolean(chat)} onClose={busy ? undefined : onClose} fullWidth maxWidth="xs">
			<DialogTitle>{labels.renameChat}</DialogTitle>
			<DialogContent>
				<TextField
					autoFocus
					fullWidth
					margin="dense"
					label={labels.chatTitle}
					value={title}
					onChange={event => setTitle(event.target.value.slice(0, 120))}
					onKeyDown={event => {
						if (event.key === 'Enter' && title.trim()) onSave(title.trim());
					}}
				/>
			</DialogContent>
			<DialogActions>
				<GuruDialogSecondaryButton onClick={onClose} disabled={busy} variant="outlined">
					{labels.cancel}
				</GuruDialogSecondaryButton>
				<GuruDialogPrimaryButton
					onClick={() => onSave(title.trim())}
					disabled={busy || !title.trim()}
					variant="contained"
					disableElevation
				>
					{labels.save}
				</GuruDialogPrimaryButton>
			</DialogActions>
		</Dialog>
	);
}

export function GuruDeleteDialog({chat, labels, busy, onClose, onConfirm}) {
	return (
		<Dialog open={Boolean(chat)} onClose={busy ? undefined : onClose} fullWidth maxWidth="xs">
			<DialogTitle>{labels.deleteChatTitle}</DialogTitle>
			<DialogContent>
				<DialogContentText>{labels.deleteChatText}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<GuruDialogSecondaryButton
					onClick={onClose}
					disabled={busy}
					variant="outlined"
				>
					{labels.cancel}
				</GuruDialogSecondaryButton>
				<GuruDialogDangerButton
					onClick={onConfirm}
					disabled={busy}
					variant="contained"
					disableElevation
				>
					{labels.deleteChat}
				</GuruDialogDangerButton>
			</DialogActions>
		</Dialog>
	);
}
